import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { OptionGroup, OptionItem } from '../../ui';
import SelectedAnswers from './SelectedAnswers';
import Continue from '../../Common/Continue';
import { useContinue } from './useContinue';
import iconAccessibility from '../../../assets/icons/icon-accesibilidad.svg';
import { setHealthValue } from '../../../actions';

const CoberturaWrapper = styled.div`
  .Cobertura {
    &-inner {
      display: flex;
    }

    &-image {
      margin-right: 60px;
      margin-left: 60px;

      img {
        width: 80px;
      }
    }

    &-content {
      flex: 1;
      text-align: left;
    }

    &-text {
      padding-left: 8px;
      font-size: 15px;
      max-width: 450px;
      line-height: 1.5;
      font-weight: 300;
      color: var(--text-color-2);
    }

    &-subtitle {
      font-weight: 600;
      font-size: 18px;
      color: var(--text-color-2);
      margin-top: 24px;
      margin-bottom: 20px;
      padding-left: 8px;
    }
  }
`;

const Cobertura = ({ capital, onValueChange }) => {
  const isValidForm = useContinue(capital !== 0);

  return (
    <CoberturaWrapper>
      <SelectedAnswers />

      <div className="Cobertura-inner">
        <div className="Cobertura-image">
          <img src={iconAccessibility} alt="" />
        </div>

        <div className="Cobertura-content">
          <p className="Cobertura-text">
            Este seguro te garantiza un dinero en caso de ser diagnosticado de
            una enfermedad grave.
          </p>

          <p className="Cobertura-subtitle">
            Selecciona cuál es el monto de dinero que te gustaría recibir
          </p>

          <OptionGroup>
            <OptionItem
              active={capital === 25000}
              onClick={() => onValueChange('capital', 25000)}
            >
              U$S 25.000
            </OptionItem>

            <OptionItem
              active={capital === 50000}
              onClick={() => onValueChange('capital', 50000)}
            >
              U$S 50.000
            </OptionItem>
          </OptionGroup>

          <Continue state={isValidForm} />
        </div>
      </div>
    </CoberturaWrapper>
  );
};

const mapStateToProps = state => {
  return {
    capital: state.health.capital
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setHealthValue(type, value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cobertura);
